/**
 * The Keylens brand mark: a framed aperture (four corner brackets around a square),
 * the lens a player's setup is seen through. SVG unchanged from the design drop;
 * `currentColor` so each host (top bar badge, drop overlay, mouse palm) tints it.
 */
export function LensMark({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      aria-hidden="true"
      viewBox="0 0 64 64"
      fill="none"
      width="100%"
      height="100%"
    >
      <path
        d="M14 22V17a3 3 0 0 1 3-3h5M50 22V17a3 3 0 0 0-3-3h-5M14 42v5a3 3 0 0 0 3 3h5M50 42v5a3 3 0 0 1-3 3h-5"
        stroke="currentColor"
        strokeWidth="3.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect x="25.5" y="25.5" width="13" height="13" rx="3.6" fill="currentColor" />
    </svg>
  );
}
